var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"layout__main-content"},[_vm._t("main-content")],2),_c('div',{staticClass:"layout__sidebar"},[_vm._t("sidebar")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }